<template>
  <div class="content">
    <van-overlay
      :show="state.loadingShow"
      @click="show = false"
      duration="0"
      class="loading-show"
    >
      <van-loading color="#12cec7" size="24px" vertical="true">
        加载中...
      </van-loading>
    </van-overlay>
    <div class="info_content">
      <returnDetail
        :gamename="state.gamename"
        :pic1="state.pic1"
        :is_pay="state.is_pay"
        :is_gq="state.is_gq"
        :is_hs="state.is_hs"
        :tkmoney="state.tkmoney"
        :paylists="state.paylists"
        :paymoney="state.paymoney"
        :thbl="state.thbl"
        :create_time="state.create_time"
        :end_time="state.end_time"
        :loadFlag="state.loadFlag"
      >
        <template #returnInfo>
          <div class="return_succes" v-if="state.is_hs">
            <p>
              <span>退还成功</span
              ><span style="color: #12CEC7">{{ state.tkmoney }}</span>
            </p>
            <p>已退还至您的余额</p>
            <p>{{ timestampToTime(state.recoveryTime) }}</p>
          </div>

          <div
            class="return_tips"
            v-if="state.is_pay && !state.is_gq && !state.is_hs"
          >
            <img src="../../../assets/game/return_tips_slice.png" alt="" />
            <span>首笔充值后2小时内可申请退款</span>
          </div>
        </template>
      </returnDetail>

      <div class="order_detail"></div>

      <div v-if="(state.is_gq && !state.is_hs) || !state.is_pay">
        <remindTips>
          <template #info>
            <p v-if="!state.is_gq">
              您还有<span style="color: #ff8000">1次</span
              >退还机会未使用，充值后，游戏体验不满意可按要求申请退还
            </p>
            <p v-if="state.is_gq">
              您未在有效期内申请退款，感谢您对平台游戏的喜爱，祝您游戏愉快！
            </p>
          </template>
        </remindTips>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="bottom_button">
      <div
        class="gogame"
        @click="gogame()"
        v-if="!state.is_pay && !state.is_gq"
      >
        去玩游戏
      </div>
      <div
        @click="applicationReturn()"
        v-if="state.is_pay && !state.is_gq && !state.is_hs"
      >
        申请退还
      </div>
      <div class="timeout" v-if="state.is_gq && !state.is_hs">已过期</div>
    </div>
  </div>
  <!-- 安心玩信息弹窗 -->
  <van-popup v-model:show="state.believedInfoFlag" style="background: none">
    <div class="believed_info">
      <div>
        <button @click="closeInfo">我知道了</button>
      </div>
      <van-checkbox v-model="state.popChecked" checked-color="#12CEC7"
        >下次不再提示</van-checkbox
      >
    </div>
  </van-popup>

  <!-- 返还弹窗 -->
  <van-popup
    v-model:show="state.returnConfirm"
    position="bottom"
    :style="{ height: '40%', background: '#fff' }"
    round
  >
    <div class="return_confirm">
      <h1>确认退还</h1>
      <p>
        当前游戏仅有一次退还机会，您的<span style="color: #ff8000"
          >小号将被收回</span
        >
        <br />您将收到:
      </p>
      <p>
        <span> 赠送余额 </span>
        <span style="color: #12CEC7">{{ state.tkmoney }}</span>
      </p>
      <button @click="returnConfirm">确定</button>
      <span class="cancel_btn" @click="state.returnConfirm = false">取消</span>
    </div>
  </van-popup>

  <!-- 验证码弹窗 -->
  <van-popup
    v-model:show="state.returnCodeFlag"
    position="bottom"
    :style="{ height: '40%', background: '#fff' }"
    round
  >
    <div class="return_code">
      <h1>输入验证码</h1>
      <p>发送到您的手机：{{ hidePhone(state.phone) }}</p>
      <!-- 密码输入框 -->
      <input
        v-model="state.verifyCode"
        @input="updateCode"
        placeholder="请输入验证码"
      />
      <button v-if="state.timer == 0" @click="sendCode">发送验证码</button>
      <button v-else disabled style="background-color: #12CEC7">
        重新发送({{ state.timer }})
      </button>

      <span class="cancel_btn" @click="state.returnCodeFlag = false">取消</span>
    </div>
  </van-popup>
</template>
<script setup>
import { reactive, ref, nextTick, onActivated } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { getQueryString } from "@/utils/location";
import { getsafeplay, getsafeplayback } from "../../../api/yzgame";
import { getverfiy } from "../../../api/yzlogin";
import { timestampToTime, hidePhone } from "@/utils/date";
import { setToken, getToken } from "@/utils/auth";
import { Toast } from "vant";
import { Local } from "@/utils/storage";
const store = useStore();
const router = useRouter();

import remindTips from "./components/reminderTips.vue";
import returnDetail from "./components/returnDetail.vue";

const state = reactive({
  gid: "",
  uid: "",
  phone: "",
  phoneNum: "",
  believedInfoFlag: false,
  popChecked: false,
  returnConfirm: false,
  returnCodeFlag: false,
  verifyCode: "",
  timer: 0,

  safeplayinfo: {},
  // 安心玩信息
  create_time: "",
  end_time: "",
  gamename: "",
  is_gq: "",
  is_hs: "",
  is_pay: "",
  paylists: [],
  paymoney: 0,
  thbl: "",
  tkmoney: 0,
  pic1: "",
  recoveryTime: "",
  loadFlag: false,
  loadingShow: false,
});

onActivated(() => {
  if (Local.get("believedInfoFlag")) {
    state.believedInfoFlag - false;
  } else {
    state.believedInfoFlag = true;
  }

  state.gid = getQueryString("gid");
  state.uid = getQueryString("uid");

  if (getQueryString("mobile")) {
    state.phone = getQueryString("mobile");
  }

  if (getQueryString("token") != "undefined") {
    setToken(getQueryString("token"));
    state.token = getQueryString("token");
  }
  state.loadFlag = false;
  state.loadingShow = true;
  getsafeplayInfo();
});

const getsafeplayInfo = async () => {
  await getsafeplay({
    gid: state.gid,
    uid: state.uid,
  }).then((res) => {
    if (res.data.code == 1) {
      state.safeplayinfo = res.data.data;
      state.create_time = res.data.data.create_time;
      state.end_time = res.data.data.end_time;
      state.gamename = res.data.data.gamename;
      state.is_gq = res.data.data.is_gq;
      state.is_hs = res.data.data.is_hs;
      state.is_pay = res.data.data.is_pay;
      state.paylists = res.data.data.paylists;
      state.paymoney = res.data.data.paymoney;
      state.thbl = res.data.data.thbl;
      state.tkmoney = res.data.data.tkmoney;
      state.pic1 = res.data.data.pic1;
      state.recoveryTime = res.data.data.recoveryTime;
      state.loadFlag = true;
    }
    state.loadingShow = false;
  });
};

// 关闭安心玩信息弹窗
const closeInfo = () => {
  Local.set("believedInfoFlag", state.popChecked);
  state.believedInfoFlag = false;
};

const gogame = () => {
  window.document.location = "gogame://" + state.gid;
};

// 申请退还
const applicationReturn = async () => {
  console.log("申请退还");
  if (!state.phone) {
    // window.JsBridge.skipUnBindPhone();
    Toast("请先绑定手机号");
    window.document.location = "skipunbindphone://";
  } else {
    state.returnConfirm = true;
  }
};

// 获取验证码实例
const returnConfirm = () => {
  console.log("确认退还");
  state.returnConfirm = false;
  state.returnCodeFlag = true;
};

// await getsafeplayback({

// }).then((res)=>{
//   console.log(res)
// })

const updateCode = async () => {
  // 限制输入长度
  if (state.verifyCode.length >= 6) {
    state.verifyCode = state.verifyCode.slice(0, 6);
    // 请求验证码接口
    await getsafeplayback({
      gid: state.gid,
      uid: state.uid,
      yzm: state.verifyCode,
    }).then((res) => {
      console.log(res);
      if (res.data.code == "1") {
        Toast(res.data.msg);
        state.verifyCode = "";
        state.returnCodeFlag = false;
        getsafeplayInfo();
      } else {
        Toast(res.data.msg);
        state.verifyCode = "";
        state.returnCodeFlag = false;
      }
    });
  }
};

// 获取验证码
var fetchFlag = false;
const sendCode = async () => {
  if (fetchFlag) return;
  fetchFlag = true;
  console.log("发送验证码");
  //获取一次
  state.timer = 59;
  let timer = null;

  // 获取验证码接口
  await getverfiy({
    val: state.phone,
    type: 22,
  }).then((res) => {
    fetchFlag = false;
    if (res.data.code != 1) {
      return;
    }
    Toast(res.data.msg);
    console.log(res);
    nextTick(() => {
      if (timer) clearInterval(timer);
      timer = setInterval(() => {
        state.timer--;
        if (state.timer == 0) {
          clearInterval(timer);
        }
      }, 1000);
    });
  });
};

const goRule = () => {
  router.push({
    path: "/game/gameBelievedRule",
  });
};
</script>
<style scoped>
.content {
  min-height: 100vh;
  padding-bottom: 200px;
  padding-top: calc(30px + constant(safe-area-inset-top));
  padding-top: calc(30px + env(safe-area-inset-top));
  background-color: #f7f8fa;
}

/* 退还成功信息 */
.return_succes {
  width: 686px;
  height: 192px;
  background: #fff;
  border-radius: 24px;
  margin-bottom: 24px;
  padding: 34px 32px;
}
.return_succes p {
  color: #999;
  font-size: 24px;
}
.return_succes p:nth-of-type(1) {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 28px;
  font-weight: 500;
  color: #333;
}
.return_succes p:nth-of-type(2) {
  margin: 20px 0 15px 0;
}

/* 退还详细信息 */
.info_content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
/* 弹窗信息 */
.believed_info {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.believed_info div:nth-child(1) {
  width: 686px;
  height: 968px;
  margin-bottom: 20px;
  background-image: url(../../../assets/game/yz_gamebelieved_popInfo.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: relative;
}
.believed_info button {
  width: 462px;
  height: 88px;
  background-color: #12cec7;
  border: none;
  border-radius: 198px;
  color: #fff;
  position: absolute;
  bottom: 82px;
  left: 114px;
}
:deep(.van-checkbox__label) {
  color: #fff;
}

.return_tips {
  width: 686px;
  height: 88px;
  border-radius: 24px;
  background: #fff;
  margin-bottom: 24px;
  color: #12cec7;
  display: flex;
  align-items: center;
}

.return_tips img {
  width: 44px;
  height: 44px;
  margin: 0 20px 0 32px;
}
.return_tips span {
  font-size: 24px;
}

/* 最底部按钮 */
.bottom_button {
  position: fixed;
  bottom: 100px;
  width: 100%;
  display: flex;
  justify-content: center;
}
.bottom_button div {
  width: 686px;
  height: 100px;
  background-color: #12cec7;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  color: #fff;
  border-radius: 198px;
  font-weight: 500;
}

/* 返还弹窗 */
.content :deep(.van-popup) {
  background-color: #1f2430;
}
.return_confirm {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 32px 0;
  background: #fff;
}
.return_confirm h1 {
  margin-bottom: 32px;
}
.return_confirm p {
  font-size: 32px;
}
.return_confirm p:nth-of-type(2) {
  margin: 32px 0 40px;
  width: 686px;
  height: 100px;
  border-radius: 16px;
  background-color: #fafafa;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
}
.return_confirm button,
.return_code button {
  width: 484px;
  height: 90px;
  background: #12cec7;
  border-radius: 198px;
  border: none;
  color: #fff;
  margin-bottom: 24px;
}
.cancel_btn {
  color: #999999;
}

.return_code {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 32px 0;
}
.return_code h1 {
  font-size: 40px;
}
.return_code p {
  width: 100%;
  margin: 32px 0 50px 0;
  text-align: left;
  font-size: 32px;
}
.return_code input {
  width: 686px;
  height: 96px;
  background-color: #fafafa;
  border: none;
  border-radius: 16px;
  font-size: 28px;
  padding: 34px 32px;
  margin-bottom: 72px;
}
:deep(.right-nr) {
  color: #12cec7;
}

.bottom_button .timeout {
  background-color: #e1e1e5;
  color: #999999;
}

.content :deep(.van-overlay) {
  background: rgba(0, 0, 0, 0.35);
}

.content :deep(.loading-show) {
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
